import React from 'react';
import './Select.scss';
import Icon from '../Icon';

// Todo: Properly migrate all of these types from Vanilla JS to TypeScript.
interface SelectProps {
  label?: string;
  className?: string;
  options: any[];
  onChange: any;
  placeholder?: any;
  disabled?: any;
  required?: any;
  value?: any;
  noOption?: any;
  block?: any;
}

const Select = ({
  label,
  className,
  options,
  onChange,
  placeholder,
  disabled,
  required = true,
  value,
  noOption,
}: SelectProps) => (
  <div className="select select--block">
    {label && (
      <div className="select__label">
        {label} {required && <div className="select__required" />}
      </div>
    )}
    <div className="select__icon" style={{ top: !label && '1.6rem' }}>
      <Icon glyph="chevron-down" weight="solid" />
    </div>
    <select
      defaultValue=""
      disabled={disabled}
      style={{ cursor: disabled && 'not-allowed' }}
      className={'select__control' + ' ' + className}
      onChange={onChange}
      value={value}
    >
      <option className="select__option" value="" disabled={required}>
        {placeholder}
      </option>
      {noOption
        ? null
        : options.map((o, i) => (
            <option className="select__option" key={i} value={o.value}>
              {o.label}
            </option>
          ))}
    </select>
  </div>
);

export default Select;
